<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('Conformar equipo')"
          :directory="$t('de evaluación')"
          :icon="'trello'"
          :preloader="preloader"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button>
        </div>
      </div>
    </div>
    <app-overlay-loader v-if="preloader" style="width: 100%" />
    <hr />

    <FullCalendar
      ref="fullCalendar"
      defaultView="dayGridMonth"
      :options="calendarOptions"
      :header="{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
      }"
      :plugins="calendarPlugins"
      :weekends="calendarWeekends"
      :events="events"
      @dateClick="openAddEditModal"
      @eventClick="handleEventClick"
      @eventDrop="handleEventDrop"
      :editable="true"
      navLinks="true"
      locale="es"
    />

    <evaluation-modal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      :evaluation="evaluation"
      :date-select="dateSelect"
      :evaluators-lider-list="evaluatorsLiderList"
      :lider-evaluator-training-list="liderEvaluatorTrainingList"
      :evaluator-list="evaluatorList"
      :evaluators-training-list="evaluatorsTrainingList"
      :observer-list="observerList"
      :technical-expert-list="technicalExpertList"
      @close-modal="closeAddEditModal"
    />

    <edit-evaluation-modal
      v-if="isEditModalActive"
      :selected-url="selectedUrl"
      :evaluation="evaluation"
      :habilite-form="habiliteForm"
      :plannification-data="plannificationData"
      :evaluators-lider-list="evaluatorsLiderList"
      :lider-evaluator-training-list="liderEvaluatorTrainingList"
      :evaluator-list="evaluatorList"
      :evaluators-training-list="evaluatorsTrainingList"
      :observer-list="observerList"
      :technical-expert-list="technicalExpertList"
      @close-modal="closeEditModal"
    />
  </div>
</template>
<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import AddEventModal from "./AddEventModal";
export default {
  name: "CalendarEvents",
  mixins: [FormMixin],
  components: {
    FullCalendar,
    AddEventModal,
  },
  props: {
    evaluationId: String,
  },

  data: () => ({
    isAddEditModalActive: false,
    isEditModalActive: false,
    events: "",
    dateSelect: "",
    preloader: false,
    plannificationData: [],
    habiliteForm: false,
    newEvent: {
      event_name: "",
      start_date: "",
      end_date: "",
      color: "",
      allDay: "",
    },
    evaluatorsLiderList: [{ id: "", value: "Selecciona una opción" }],
    liderEvaluatorTrainingList: [{ id: "", value: "Selecciona una opción" }],
    evaluatorList: [{ id: "", value: "Selecciona una opción" }],
    evaluatorsTrainingList: [{ id: "", value: "Selecciona una opción" }],
    observerList: [{ id: "", value: "Selecciona una opción" }],
    technicalExpertList: [{ id: "", value: "Selecciona una opción" }],

    new_event_modal_open: false,
    event_detail_modal_open: false,
    new_event_details: {
      start: null,
      end: null,
    },

    current_event: null,
    show_event_details_modal: false,
    evaluation: Object,

    /* Full Calendar Options Start */

    calendarPlugins: [dayGridPlugin, interactionPlugin],
    calendarWeekends: true,
    // calendarEvents: {
    //   url: '/accreditationtechnical/planningteam/evaluationList'
    // },
    calendarOptions: {
      eventLimit: true,
      views: {
        timeGrid: {
          eventLimit: 4,
        },
        monthGrid: {
          eventLimit: 4,
        },
        dayGrid: {
          eventLimit: 4,
        },
      },
    },
    /* Full Calendar Options End */
  }),
  created() {
    this.preloader = true;
    this.getEvaluatorsLiderList();
    this.evaluationData();
    this.getEvents();
    this.evaluationSelectData();
  },

  methods: {
    returnPage() {
      window.location.replace(document.referrer);
      // window.location.href =
      //   "/accreditationtechnical/planningteam/planning/" + this.evaluationId;
    },

    reSetData() {
      this.getEvents();
    },

    evaluationData() {
      this.preloader = true;
      let selectedUrl = `${actions.PLANNING_TEAM}/planningData/${this.evaluationId}`;
      this.axiosGet(selectedUrl).then((response) => {
        this.evaluation = response.data.evalTest;
        this.preloader = false;
      });
    },

    getEvents() {
      axios
        .get(`/accreditationtechnical/planningteam/evaluationList?evalTest=${this.evaluationId}`)
        .then(
          (resp) => ((this.events = resp.data.data), (this.preloader = false))
        )
        .catch((err) => console.log(err.response.data));
    },

    closeAddEditModal() {
      $("#asign-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    getEvaluatorsLiderList() {
      var selectedUrl = `${actions.PLANNING_TEAM}/evaluatorsLiderList`;
      axios.get(selectedUrl).then((response) => {
        this.evaluatorsLiderList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.evaluators,
        ];

        this.liderEvaluatorTrainingList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.lider_evaluator_training,
        ];

        this.evaluatorList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.evaluator,
        ];

        this.evaluatorsTrainingList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.evaluator_training,
        ];

        this.observerList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.observator,
        ];
        console.log(this.observerList);

        this.technicalExpertList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.technical_experts,
        ];
      });
    },

    handleDateClick(e) {
      this.new_event_modal_open = true;
      this.new_event_start = e.dateStr;
      let endTime = new Date(e.dateStr).toISOString();
      this.new_event_details.start = e.dateStr;
      this.new_event_details.end = endTime;
    },

    handleEventDrop(e) {
      let updatedEventData;
      if (e.event.end == null) {
        updatedEventData = {
          id: e.event.id,
          start: e.event.start,
          end: e.event.start,
        };
      } else {
        updatedEventData = {
          id: e.event.id,
          start: e.event.start,
          end: e.event.end,
        };
      }

      if (this.evaluationId == e.event.id) {
        var selectedUrl = `${actions.PLANNING_TEAM}/updateDrop`;
        axios.post(selectedUrl, updatedEventData).then((response) => {
          this.$toastr.s(this.$t("updated_success"));
        });
      } else {
        e.revert();
        this.$toastr.e("No tiene autorización para realizar esta acción");
      }
    },

    evaluationSelectData() {
      var selectedUrl = `${actions.PLANNING_TEAM}/showEvaluation/${this.evaluationId}`;
      axios.get(selectedUrl).then((response) => {
      });
    },

    handleEventClick(e) {
      var selectedUrl = `${actions.PLANNING_TEAM}/showEvaluation/${e.event.id}`;
      axios.get(selectedUrl).then((response) => {
        this.plannificationData = response.data;
        if (
          this.plannificationData.evaluation.id == Number(this.evaluationId)
        ) {
          this.habiliteForm = true;
          this.isEditModalActive = true;
          this.current_event = e.event;
          this.show_event_details_modal = true;
        } else {
          this.habiliteForm = false;
          this.isEditModalActive = true;
          this.current_event = e.event;
          this.show_event_details_modal = true;
        }
      });
    },

    openAddEditModal(e) {
      var dateSelect = e.dateStr;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; 
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var today = yyyy + "-" + mm + "-" + dd;
      
      if(dateSelect > today){
        this.dateSelect = new Date(e.date);
        this.isAddEditModalActive = true;
      }else{
        this.$toastr.e(this.$t("No puedes realizar planificaciones para hoy o días anteriores"));
      }
    },

    closeAddEditModal() {
      $("#asign-add-edit-modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    closeEditModal() {
      $("#asign-edit-modal").modal("hide");
      this.isEditModalActive = false;
      this.reSetData();
    },

    formatDate(date) {
      return moment.utc(date).format("DD/MM/YY HH:mm");
    },

    resetNewEventData() {
      this.new_event_details.start = null;
      this.new_event_details.end = null;
      this.new_event_details.title = null;
      this.new_event_modal_open = false;
    },

    newEventCreated() {
      this.rerenderCalendar();
      this.new_event_modal_open = false;
      this.resetNewEventData();
      new Noty({
        text: `Appointment has been created.`,
        timeout: 1000,
        type: "success",
      }).show();
    },

    eventResize(e) {
      let updatedEventData = {
        start: e.event.start,
        end: e.event.end,
      };
      this.$api.appointments
        .update(e.event.id, updatedEventData)
        .then(({ data }) => {
          new Noty({
            text: `Appointment duration updated.`,
            timeout: 1000,
            type: "success",
          }).show();
        })
        .catch((error) => {
          e.revert();
          new Noty({
            text: `Oooops, couldn't update appointment duration. Sorry.`,
            timeout: 1000,
            type: "error",
          }).show();
        });
    },

    rerenderCalendar() {
      this.$refs.fullCalendar.getApi().refetchEvents();
    },
    
  },
};
</script>
<style>
.fc-content {
  color: white;
}

</style>
